const prependZero = (num: number) => (num < 10 ? `0${num}` : num);

// examples: 12:00am, 1:09pm
export default function formatTime(date: Date): string {
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'pm' : 'am';
  const formattedHours = ((hours + 11) % 12) + 1;
  const formattedMinutes = prependZero(minutes);

  return `${formattedHours}:${formattedMinutes}${ampm}`;
}
